import React from 'react';
import ContactPage from './contact';

export default function render(entry, pageTree) {
    return <ContactPage entry={entry} pageTree={pageTree} />;
}
